import { DialogType } from '../../common/enums.js';
import {
  listedNumberMsg,
  notToDirectoryMsg,
  t,
  unlistedMsg,
  youCanMakeChangesAfterSubActivatedMsg,
} from '../../common/i18n/index.js';
import { DirectoryDetails } from '../../generated/api/directoryDetails.js';
import { SubscriptionDetailsMobile } from '../../generated/api/subscriptionDetailsMobile.js';
import { openDialog } from '../../public/site/dialogStore.js';
import type { PurposeOfUseOrContact } from '../../common/types/subscription.js';
import type { CompanyInfoResponse } from '../../generated/api/companyInfoResponse.js';
import type { Subscription } from '../../generated/api/subscription.js';

const getNumberPublicityRadioOptions = () => [
  {
    label: t.ZGKE(unlistedMsg),
    value: SubscriptionDetailsMobile.DirectoryListingEnum.SECRET,
  },
  {
    label: t.KC80(notToDirectoryMsg),
    value: SubscriptionDetailsMobile.DirectoryListingEnum.NOT_TO_DIRECTORY,
  },
  {
    label: t.SCL4(listedNumberMsg),
    value: SubscriptionDetailsMobile.DirectoryListingEnum.CUSTOM,
  },
];

export const getNumberPublicityOptions = (hideNotToDirectory: boolean) =>
  hideNotToDirectory
    ? getNumberPublicityRadioOptions().filter(i => i.value !== DirectoryDetails.NumberDirectoryEnum.NOT_TO_DIRECTORY)
    : getNumberPublicityRadioOptions();

const getCompanyName = (directoryDetails?: DirectoryDetails, companyInfo?: CompanyInfoResponse) =>
  !directoryDetails?.companyName &&
  directoryDetails?.numberDirectory !== DirectoryDetails.NumberDirectoryEnum.CUSTOM &&
  companyInfo
    ? companyInfo.companyName
    : directoryDetails?.companyName;

export const getVoiceDirectoryDetails = (
  purposeOfUseOrContact: PurposeOfUseOrContact,
  companyInfo?: CompanyInfoResponse
) => {
  const voiceDirectoryDetails = purposeOfUseOrContact.directoryListingMobileNumberPublicity?.voiceDirectoryDetails;
  const companyName = getCompanyName(voiceDirectoryDetails, companyInfo);
  return voiceDirectoryDetails
    ? { voiceDirectoryDetails: { ...voiceDirectoryDetails, companyName: companyName } }
    : undefined;
};

export const getPbxDirectoryDetails = (
  purposeOfUseOrContact: PurposeOfUseOrContact,
  companyInfo?: CompanyInfoResponse
) => {
  const pbxDirectoryDetails = purposeOfUseOrContact.directoryListingCorporateNumberPublicity?.pbxDirectoryDetails;
  const companyName = getCompanyName(pbxDirectoryDetails, companyInfo);
  return pbxDirectoryDetails
    ? { pbxDirectoryDetails: { ...pbxDirectoryDetails, companyName: companyName } }
    : undefined;
};

export const changeNumberPrivacyPublicToCustom = (
  numberPrivacy?: DirectoryDetails.NumberDirectoryEnum
): DirectoryDetails.NumberDirectoryEnum | undefined =>
  numberPrivacy === DirectoryDetails.NumberDirectoryEnum.PUBLIC_DIRECTORY
    ? DirectoryDetails.NumberDirectoryEnum.CUSTOM
    : numberPrivacy;

export const subscriptionSuspendedDialog = (subscription: Subscription): void =>
  openDialog({
    body: <>{t.J07S(youCanMakeChangesAfterSubActivatedMsg)}</>,
    subscriptionId: subscription.subscriptionId,
    type: DialogType.SUBSCRIPTION_RESUME_FROM_TEMPORARILY_CLOSE,
  });

export const subscriptionActionsPendingDialog = (): void =>
  openDialog({ type: DialogType.SUBSCRIPTION_ACTION_PENDING });

export const subscriptionInActivationDialog = (): void =>
  openDialog({ type: DialogType.MACD_FORBIDDEN_SUBSCRIPTION_IN_ACTIVATION });
